var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.89062 0C7.80412 0 8.6802 0.362884 9.32614 1.00882C9.97208 1.65476 10.335 2.53084 10.335 3.44434C10.335 4.35783 9.97208 5.23391 9.32614 5.87985C8.6802 6.52579 7.80412 6.88867 6.89062 6.88867C5.97713 6.88867 5.10105 6.52579 4.45511 5.87985C3.80917 5.23391 3.44629 4.35783 3.44629 3.44434C3.44629 2.53084 3.80917 1.65476 4.45511 1.00882C5.10105 0.362884 5.97713 0 6.89062 0ZM6.89062 8.61084C10.6966 8.61084 13.7793 10.1522 13.7793 12.0552V13.7773H0.00195312V12.0552C0.00195312 10.1522 3.08463 8.61084 6.89062 8.61084Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.678e8616176028204ea236b30e789e44.svg";
export { ForwardRef as ReactComponent };